import React, { useState, useEffect, Profiler } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardActionArea, CardActions, CardContent, CardMedia, Button, Typography, Grid } from '@material-ui/core';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import ProfilePic from '../../../Assets/images/profile-pic.png';
import UserRating from './UserRating';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer'
import axios from 'axios';


const useStyles = makeStyles((theme) => ({
  cardContainer: {
    maxWidth: 300,
  },

  gridContainer: {
    margin: theme.spacing(2),
    alignItems:"center", 
    justifyContent:"center",
    margin: 'auto',
    height: '100vh'
  },

  containerItems: {
    margin: theme.spacing(2),
  },

  CardActionArea: {
    display: 'flex', 
    alignItems:"center", 
    justifyContent:"center", 
    padding: '5px 0 15px 0'
  },

  disabledButton: {
    width: '94%',
    background: '#15616d',
    color: 'grey',
    textTransform: 'capitalize',
    '&:hover': {
        // background: '#40916c',
        cursor: 'default',
        background: '#15616d',
    },
    '&:focus':{
        outline: 'none'
    }
},   
}));

// const userProfiles = [
//   {
//     name: 'Bruce Lee',
//     image: ProfilePic,
//     countryCode: 'DE',
//     city: 'Köln',
//   },
//   {
//     name: 'Crazy Monkey',
//     image: ProfilePic,
//     countryCode: 'GBR',
//     city: 'London',
//   },
//   {
//     name: 'Okoyowski Lewendowski',
//     image: 'http://placeimg.com/640/480/transport',
//     countryCode: 'POL',
//     city: 'Warsaw',
//   },
//   {
//     name: 'Little Headless Chicken',
//     image: ProfilePic,
//     countryCode: 'FR',
//     city: 'Paris',
//   },
//   {
//     name: 'Okoyowski Lewendowski',
//     image: ProfilePic,
//     countryCode: 'POL',
//     city: 'Warsaw',
//   },
//   {
//     name: 'Okoyowski Lewendowski',
//     image: ProfilePic,
//     countryCode: 'POL',
//     city: 'Warsaw',
//   },
// ]


const Profile = () => {
  const classes = useStyles();



  const [transporterProfiles, setTransporterProfiles] = useState(null);

  useEffect(() => {
  //   const fetchTransporterProfiles = async () => {
  //     const transporterProfiles = await axios
  //       .get("/api/transporters")
  //       // .then(data => console.log(data.data[1]));
  //       .then(result => result.data);
  //     return transporterProfiles;
  //   };
  //   fetchTransporterProfiles().then((res) => setTransporterProfiles(res));
  axios.get("/api/transporters")
  .then(result => setTransporterProfiles(result.data))
  .catch(error => console.log(error)
  )
}, []);

  return (
    <>
      <Navbar/>
      <Grid container className={classes.gridContainer}>
        {
          transporterProfiles && transporterProfiles.map((profile) =>
          // userProfiles && userProfiles.map((profile) =>
          <Grid item className={classes.containerItems}>
            <Card className={classes.cardContainer} >
              <CardActionArea>
                <CardMedia
                  style={{width: '100%', height: '50%',}}
                  component="img"
                  alt="Profile picture"
                  // style={{borderRadius: '50%'}}
                  image={profile.picture}
                  title="Profile Picture"
                />
                <CardContent style={{height: '110px',  padding: '10px 16px 0 16px'}}>
                  <Typography gutterBottom variant="h5" component="h2" style={{textAlign: 'center', color: '#6360F6'}}>
                    {profile.first_name} {profile.last_name}
                  </Typography>
                  <Typography variant="body2" color="textSecondary" component="p" style={{textAlign: 'center'}}>
                    <LocationOnIcon />{profile.category}
                  </Typography>
                    <UserRating/>          
                </CardContent>
              </CardActionArea>
              <CardActions className={classes.CardActionArea}>
                <Button size="large" variant="contained" className={classes.disabledButton} >View Profile</Button>
              </CardActions>
            </Card>
            </Grid>
          )
        }
        <Footer/>
      </Grid>
    </>
  );
}


export default Profile;